//
//
//
//
//
//
//
//
//

import uuidMixin from '../../mixins/uuid'

export default {
  mixins: [uuidMixin],
  props: {
    value: Boolean
  },
  created () {
    this.currentValue = this.value
  },
  data () {
    return {
      currentValue: false
    }
  },
  watch: {
    value (val) {
      this.currentValue = val
    },
    currentValue (val) {
      this.$emit('input', val)
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/agree/index.vue